angular
    .module("skillBuilderSaaS")
    .directive("sideNavigation", (["$timeout", "$transitions", function ($timeout, $transitions) {
        return {
            restrict: "A",
            link: function (scope, element) {
                scope.$watch("vm.menu", function () {
                    if (scope.vm.menu === undefined)
                        return;
                    $timeout(function () {
                        element.metisMenu({
                            activeClass: "mm-active"
                        });
                    });
                });
                //element.on('show.metisMenu hide.metisMenu', function (e) {
                //	var itemId = $(e.target).attr('id');
                //	var state = e.type === 'show';
                //	//menuState[itemId] = state;
                //	//menuStateService.setMenuState(menuState);
                //});
                $transitions.onSuccess({}, function () {
                    $timeout(function () {
                        var $el1 = $('.mm-show').not('.mm-active .mm-show');
                        if ($el1.length) {
                            //console.log("directive remove mm-show");
                            $el1.removeClass('mm-show');
                        }
                        var $el2 = $('.mm-active .sub-menu');
                        if ($el2.length) {
                            if (!$el2.hasClass('mm-show')) {
                                //console.log("directive add mm-show height ''");
                                $el2.addClass('mm-show').height('');
                            }
                        }
                    }, 100);
                });
            }
        };
    }]));
